export class ReelsEvents {
	public static readonly SPIN_ENDED: string = 'ReelsEvents::__SPIN_ENDED__';
	public static readonly AVALANCHE_ENDED: string = 'ReelsEvents::__AVALANCHE_ENDED__';
	public static readonly REELS_SPINNING_STARTED: string = 'ReelsEvents::__REELS_SPINNING_STARTED__';
	public static readonly REELS_RESPIN_STARTED: string = 'ReelsEvents::__REELS_RESPIN_STARTED__';
	public static readonly REELS_AVALANCHE_STARTED: string = 'ReelsEvents::__REELS_AVALANCHE_STARTED__';
	public static readonly REEL_STOPPED: string = 'ReelsEvents::__REEL_STOPPED__';
	public static readonly ALL_REELS_STOPPED: string = 'ReelsEvents::__ALL_REELS_STOPPED__';
	public static readonly REEL_PERCIEVED_STOP: string = 'ReelsEvents::REEL_PERCIEVED_STOP';

	public static readonly REELS_FADING_OUT_FINISHED: string = 'ReelsEvents::REELS_FADING_OUT_FINISHED';
	public static readonly REELS_FADING_OUT_STARTED: string = 'ReelsEvents::REELS_FADING_OUT_STARTED';
	public static readonly REELS_FADING_IN_FINISHED: string = 'ReelsEvents::REELS_FADING_IN_FINISHED';
	public static readonly REELS_FADING_IN_STARTED: string = 'ReelsEvents::REELS_FADING_IN_STARTED';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/reels/spin/ReelsEvents.ts